import { render, staticRenderFns } from "./BuildingEmergencyModal.vue?vue&type=template&id=707f76b5&"
import script from "./BuildingEmergencyModal.vue?vue&type=script&lang=js&"
export * from "./BuildingEmergencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports